import React from "react";
import { Home, CalendarClock, MessageCircle, Settings } from "lucide-react";

const TABS = [
  { key: "home", label: "Accueil", Icon: Home },
  { key: "activity", label: "Activité", Icon: CalendarClock },
  { key: "messages", label: "Messages", Icon: MessageCircle },
  { key: "settings", label: "Réglages", Icon: Settings },
];

// Barre d'onglets fixe en bas (passager & conducteur).
export default function PriceBottomTabs({ active, onChange, badges = {}, prefix }) {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 bg-white border-t-2 border-black"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid={`${prefix}-bottom-tabs`}
    >
      <div className="mx-auto grid max-w-md grid-cols-4">
        {TABS.map(({ key, label, Icon }) => {
          const on = active === key;
          const n = Number(badges[key] || 0);
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              className="relative flex flex-col items-center gap-0.5 py-2.5 transition-transform active:scale-95"
              data-testid={`${prefix}-tab-${key}`}
              aria-current={on ? "page" : undefined}
            >
              <span className={`grid h-8 w-12 place-items-center rounded-full transition-colors ${on ? "bg-primary text-primary-foreground street-border-thin" : "text-foreground/60"}`}>
                <Icon className="h-[18px] w-[18px]" strokeWidth={2.75} />
              </span>
              <span className={`text-[10px] font-black uppercase tracking-wider ${on ? "text-primary" : "text-foreground/55"}`}>{label}</span>
              {n > 0 && (
                <span className="absolute right-[22%] top-1 grid h-5 min-w-5 place-items-center rounded-full bg-primary px-1 text-[10px] font-black text-primary-foreground street-border-thin" data-testid={`${prefix}-tab-${key}-badge`}>
                  {n}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
